<script lang="ts">
  export let key: string;
</script>

{#if key === 'canesFromLib'}
  Some canes are randomly generated while others exist in real world paperweights.
  Indicates the number of canes within that paperweight that exist as is in real world paperweights.
{:else if key === 'randomCanes'}
  Number of canes which are generated randomly.
{:else if key === 'layoutType'}
  The general layout of the paperweight. 3 possibles values: <span class="code">closepack</span>, <span class="code">concentric</span>, or <span class="code">delaunay</span>.
{:else if key === 'generalStyle'}
  The general style of the chosen canes. This has an important impact on the general style of the paperweight.<br/>
  <table>
    <tbody>
      <tr>
        <th scope="row">cogs</th>
        <td>favor cogwheel like canes, very angular (which is very typical of Murano)</td>
      </tr>
      <tr>
        <th scope="row">smoothCogs</th>
        <td>still cogwheels, but the tooth have smooth angles</td>
      </tr>
      <tr>
        <th scope="row">pinchedCircles</th>
        <td>like a cog, but each teeth looks like the part of a circle</td>
      </tr>
      <tr>
        <th scope="row">simpleCircles</th>
        <td>favor concentric circles</td>
      </tr>
      <tr>
        <th scope="row">allMixed</th>
        <td>no specific style, each cane has a random style</td>
      </tr>
    </tbody>
  </table>
  Even if a paperweight has a specific general style (e.g. <span class="code">cogs</span>), the chosen canes will often be mixed.
{:else if key === 'simplestCane'}
  The number of elements of the simplest cane of the paperweight.
{:else if key === 'mostComplexCane'}
The number of elements of the most complex cane of the paperweight.
{:else if key === 'hasCentralCane'}
  Indicates if the paperweight has a central cane (in the very center).
  <span class="code">Concentric</span> paperweights always have a central cane.
{:else if key === 'numberOfCanes'}
  The total number of canes.
{:else if key === 'caneSetType'}
  <p>Indicates how, within a layout, the canes were chosen.</p>
  When the layout is <span class="code">closepack</span> or <span class="code">delaunay</span>:
  <table>
    <tbody>
      <tr>
        <th scope="row">allDifferent</th>
        <td>all the canes are different (each is unique)</td>
      </tr>
      <tr>
        <th scope="row">classic</th>
        <td>there is cane diversity, but most canes are present multiple times</td>
      </tr>
    </tbody>
  </table>


  When the layout is <span class="code">concentric</span>:
  <table>
    <tbody>
      <tr>
        <th scope="row">1pattern</th>
        <td>all canes are the same, except the central cane</td>
      </tr>
      <tr>
        <th scope="row">2pattern</th>
        <td>around the central cane, there are circles made with the same cane, in a 1-2-1-2... pattern</td>
      </tr>
      <tr>
        <th scope="row">3pattern</th>
        <td>same as <span class="code">2pattern</span> but with a 1-2-3-1-2-3... pattern</td>
      </tr>
      <tr>
        <th scope="row">allGarlandsDifferent</th>
        <td>each circle is made of different canes</td>
      </tr>
    </tbody>
  </table>

{:else if key === 'uniqueCanes'}
  The number of canes that are unique (present only once) within this paperweight.
{:else if key === 'differentCanes'}
  The total number of different canes.
{:else if key === 'diversity'}
  The cane diversity of the paperweight. It is equal to <span class="code">differentCanes / numberOfCanes</span>.
  When all canes are unique, its value is 1.
{:else if key === 'hasSignatureCane'}
  Indicates if the paperweight contains one (or more) signature canes.
  Some paperweights are signed, some are not.
{:else if key === 'hasSecondSignature'}
  Indicates if a signed paperweight has a second signature.
  Some paperweights are double signed, probably by mistake...
{:else if key === 'hasRareSignature'}
  Some signed paperweights have a non standard, rare signature, that might appear instead of or complementary to a standard signature.
{:else if key === 'concentricCircles'}
  When the layoutType is <span class="code">concentric</span>, indicates the number of concentric circles of canes around the central cane (including the central cane).
{:else if key === 'lastGarlandAlternate'}
  When the layoutType is <span class="code">concentric</span>, the last circle of canes (the one closest to the border) can sometimes be made of alternate canes: 2 different canes alternated instead of just 1.
{:else}
  TODO
{/if}


<style>
  .code, th[scope='row'] {
    font-style: italic;
  }
</style>